import React, { useState, useEffect } from "react";

const GoToReviewPageButton = (props) => {
  // Retrieve the value from local storage or default to false
  const storedButtonVisibility = JSON.parse(localStorage.getItem("isButtonVisible")) || false;
  const [isButtonVisible, setButtonVisibility] = useState(storedButtonVisibility);

  useEffect(() => {
    // Update local storage whenever isButtonVisible changes
    localStorage.setItem("isButtonVisible", JSON.stringify(isButtonVisible));
  }, [isButtonVisible]);

  useEffect(() => {
    // Retrieve the page number from local storage
    const storedPageNo = localStorage.getItem("pageNo");

    // Check if the stored page number is 1 and set the button visibility accordingly
    if (storedPageNo && parseInt(storedPageNo) === 11) {
      setButtonVisibility(true);
    }
  }, []);

  const handleButtonClick = () => {
    setButtonVisibility(!isButtonVisible);
    props.update(true);
  };

  return (
    <>
      {isButtonVisible && (
        <button
          className="btn btn-primary"
          style={{ position: "fixed", bottom: "20px", right: "20px" }}
          onClick={handleButtonClick}
        >
          Go to Review Details Page
        </button>
      )}
    </>
  );
};

export default GoToReviewPageButton;
